"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.softwareUpgradeProposal = void 0;
var ow_1 = __importDefault(require("ow"));
var codec_1 = require("../../../../cosmos/v1beta1/codec");
var ow_types_1 = require("../ow.types");
var typeurl_1 = require("../../../common/constants/typeurl");
exports.softwareUpgradeProposal = function () {
    return (function () {
        function SoftwareUpgradeProposal(options) {
            ow_1.default(options, 'options', ow_types_1.owSoftwareUpgradeProposalOptions);
            this.title = options.title;
            this.description = options.description;
            this.plan = options.plan;
        }
        SoftwareUpgradeProposal.prototype.getEncoded = function () {
            var softwareUpgradeProposalOptions = {
                title: this.title,
                description: this.description,
                plan: this.plan,
            };
            var softwareUpgradeProposalContent = codec_1.cosmos.upgrade.v1beta1.SoftwareUpgradeProposal.create(softwareUpgradeProposalOptions);
            return codec_1.google.protobuf.Any.create({
                type_url: typeurl_1.COSMOS_MSG_TYPEURL.upgrade.SoftwareUpgradeProposal,
                value: codec_1.cosmos.upgrade.v1beta1.SoftwareUpgradeProposal.encode(softwareUpgradeProposalContent).finish(),
            });
        };
        return SoftwareUpgradeProposal;
    }());
};
//# sourceMappingURL=SoftwareUpgradeProposal.js.map